var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneContactPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_3411_679)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3411_679",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3411_679",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3411_679",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAYNJREFUSA2tlSFORDEQhj+BQCARCASSAyAQCAQCieAICAQCgUAgkAhuAIKEdZCAwMER8BgSBAISBIIL8L7kNek2fd1tdyd5eW1nOjP9558WxmUZOOo/x3OVLeALuAAu+7Frc5HNjMN94BeYOcgS8AHsZlINQUygWXQyKuxW/95Bt1iwKapOAb+SPAEbJYOSbg94LBgECFcLNkXVAvA5UAN1d8B10cMUykDRlcR2DfgDtpP1pukZ8AyYdSw7wA+wHi+2jHX8AhgoFZlkEzbXITgUIh2ZdSrHwBuQwpjaTZyHeuRoed4HmfkkQiKzcrh7Ek8Z6ySDCVU140EBEhOw8LLrCvgGXvsrp+paseBDuFsnKXzf3b42o2Lg6gsyBIkh6f0hNCmtm4IIlzXJFT4Ei/8GsU5Vj1bYlKNw7DyMb7raHIbJtP9AYemaQpP68P7y+a0WG82O91oZ6oeQSBVEcSZmb/HFOX0JnbtukJlFJxb/ATgBblt6YVIWdq+PlieSCGPd/A95MkQchzvAbwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneContactPage);
export default __webpack_public_path__ + "static/media/phone-contact-page.d3df3e149bbaaaaabe991e9f74e05fb1.svg";
export { ForwardRef as ReactComponent };